import React from 'react';
import './css/typography.css'; // Importez le fichier CSS
import './css/Popup.css';

const Popup = ({ content, closePopup }) => {
  const handleClickOutside = (e) => {
    if (e.target.className === 'popup') {
      closePopup();
    }
  };

  const handleContentClick = (e) => {
    e.stopPropagation();
  };

  return (
<div className="popup" onClick={handleClickOutside}>
  <div className="popup-content text-small" onClick={handleContentClick}>
    {content}
  </div>
</div>

  );
};

export default Popup;